/**
 * Add class to Element.classList
 *
 * @param {Element} element target
 * @param {string} classNAME to add
 */
export default function addClass(element, classNAME) {
  element.classList.add(classNAME);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/shorter-js/src/class/addClass.js
// module id = 5
// module chunks = 0